/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        $('#cover').click(function() {
          $('.js-navigation-toggle').click();
        });

        $( window ).scroll(function() {
          if($(this).scrollTop()>178){
            $('header.stuck').addClass('sticky');
            $('.toTop').show();
          }else{
            $('header.stuck').removeClass('sticky');
            $('.toTop').hide();
          }
        });

        $('.nav-primary .sub-menu').first().append($('.tagalong').html());

        $('.mobile .menu-item-has-children').each(function() {

          $(this).find('a').first().click(function(e){
            e.preventDefault();
            if($(this).parent().hasClass('dropdown')){
              $(this).parent().removeClass('dropdown');
              $(this).parent().find('.sub-menu').removeClass('open');
            }else{
              $(this).parent().addClass('dropdown');
              $(this).parent().find('.sub-menu').addClass('open');
            }
          });
        });

        function matchTheHeights(){
          $('#menu-primary-navigation li:nth-child(2) .sub-menu li .sub-menu').matchHeight();
        }
        
        $( window ).resize(function() {
          matchTheHeights();
          $('#mobile-nav-menu').height(window.innerHeight);
        });
        
        matchTheHeights(); 

        function hamburgerClose(el){
          el.removeClass('hamburger-active');
          $('html').removeClass( 'hamburger-active' );
          $('#mobile-nav-menu').removeClass('active');
        }

        function hamburgerOpen(el){
          el.addClass('hamburger-active');
          $('html').addClass( 'hamburger-active' );
          $('#mobile-nav-menu').addClass('active');
          $('#mobile-nav-menu').height(window.innerHeight);
        }

        $('.js-navigation-toggle').click(function() {
          if($(this).hasClass('hamburger-active') ){
            hamburgerClose($(this)); 
          }else{
            hamburgerOpen($(this));
          }
        });

        $('#menu-mobile-nav-contact').appendTo($('#menu-mobile-nav-footer'));

        $('#menu-primary-navigation-1 li a:not(.sub-menu li a)').attr('href','javascript:void(0);');
        $('#menu-footer-navigation li a:not(.sub-menu li a)').attr('href','javascript:void(0);');

        $('.ul').parent().parent().addClass('ul_separator');
        
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
